import undoable, { excludeAction } from 'redux-undo';
import { TemplateAction } from './action-types';
import coreReducer from './core';
import backgroundReducer from './modules/background';
import captionsReducer from './modules/captions';
import edgeVideoReducer from './modules/edge-video';
import layerReducer from './modules/layers';
import progressReducer from './modules/progress';
import slideshowReducer from './modules/slideshow';
import templateReducer from './modules/template';
import textReducer from './modules/text';
import timerReducer from './modules/timer';
import videoReducer from './modules/video';
import watermarkReducer from './modules/watermark';
import waveformReducer from './modules/waveform';
import { Action, VideoTemplateStateContent } from './types';

const reducers = [
  coreReducer,
  backgroundReducer,
  captionsReducer,
  edgeVideoReducer,
  layerReducer,
  progressReducer,
  slideshowReducer,
  templateReducer,
  textReducer,
  timerReducer,
  videoReducer,
  watermarkReducer,
  waveformReducer,
];

function reducer(
  state: VideoTemplateStateContent,
  action: Action,
): VideoTemplateStateContent {
  return reducers.reduce((currentState, sliceReducer) => {
    // safe because TemplateAction is a union of Action variants
    const templateAction = action as TemplateAction;
    return sliceReducer(currentState, templateAction);
  }, state);
}

const undoableReducer = undoable(reducer, {
  filter: excludeAction([
    'xstate.init',
    'CONTAINER_RESIZE',
    'IMAGE_LOAD',
    'CHILD_VIEW_CLOSE',
    'CHILD_VIEW_OPEN',
  ]),
  limit: 50,
  syncFilter: true,
});

export default undoableReducer;
